/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { Button, Modal, IconButton, Select, MenuItem, InputBase } from '@mui/material';
import { styled } from '@mui/system';
import { isEmpty, reverse } from 'lodash';

import '../scss/data-model.scss';
import Color from '@tool/color';
import moCapital, {
  canSure,
  changeDataTime, changeModel, changeProfit, changeRevemue, changeSalary,
  profitBlurs, profitFocus, revemueBlurs, revemueFocus, salaryBlurs, salaryFocus,
} from '../store/capital-analysis';
import { CloseIcon20 } from '@/styled/icon';
import moEffect from '../../store';
import WorkService from '@/service/work';


interface IProps { }
interface IState { }

const DModal = styled(Modal)(() => ({
  zIndex: 556,
}));

const DSelect = styled(Select)(() => ({
  width: '140px',
  zIndex: 5555556,
  height: '36px',
  backgroundColor: Color.f7,
  border: 0,
  borderRadius: '5px',
  '& .MuiSelect-select': {
    display: 'inline-flex',
    alignItems: 'center',
    paddingTop: '8px',
    paddingBottom: '8px',
    fontSize: '14px',
    fontWeight: 500,
    color: Color.primary,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 0,
  },
}));


const DMenuItem = styled(MenuItem)(() => ({
  fontSize: '14px',
  color: Color.c333,
}));

const DInputBase = styled(InputBase)(() => ({
  width: '120px',
  height: '36px',
  border: 0,
  backgroundColor: Color.f7,
  fontSize: '14px',
  fontFamily: 'Roboto',
  color: Color.primary,
  paddingTop: '3px',

  '& input': {
    fontSize: '14px',

    '&::placeholder': {
      fontSize: '14px',
    },
  },
}));


const DataModel = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { dataYear, isDataModel, revenue, profit, salary, revenueFlag, salaryFlag, profitFlag } = moCapital;

  const yearChange = (event: any) => {
    changeDataTime(event.target.value);
  };

  const closeModel = () => {
    changeModel(false);
  };

  // 人均收入
  const revenueChange = (e: any) => {
    changeRevemue(e.target.value);
  };

  // 人均净利润

  const profitChange = (e: any) => {
    changeProfit(e.target.value);
  };

  // 人均净利润

  const salaryChange = (e: any) => {
    changeSalary(e.target.value);
  };


  useEffect(() => {
    return () => { };
  }, []);

  return (
    <DModal open={isDataModel}>
      <section className="data-model-warp">
        <p className='model-top'>添加我的数据
          <span onClick={closeModel}>
            <CloseIcon20 width={14} height={14} color={Color.white} />
          </span>
        </p>
        <section className='content-item'>
          <p>选择年份 :</p>
          <DSelect
            value={dataYear}
            onChange={yearChange}
            inputProps={{ 'aria-label': 'Without label' }}>
            {
              moEffect.funYearList?.map((res: any, r: any) => {
                return <DMenuItem value={res} key={`${r}`}>
                  {`${res}年`}
                </DMenuItem>;
              })
            }
          </DSelect>
        </section>
        <section className='content-item'>
          <p>人均营业收入 :</p>
          <section className='input-group'>
            <DInputBase value={revenue} onChange={revenueChange}
              onFocus={revemueFocus} onBlur={revemueBlurs} />
            元
          </section>
          {revenueFlag && <span>请填写人均营业收入</span>}
        </section>
        <section className='content-item'>
          <p>人均净利润 :</p>
          <section className='input-group'>
            <DInputBase value={profit} onChange={profitChange}
              onFocus={profitFocus} onBlur={profitBlurs} />
            元
          </section>
          {profitFlag && <span>请填写人均净利润</span>}
        </section>
        <section className='content-item'>
          <p>人均薪酬成本 :</p>
          <section className='input-group'>
            <DInputBase value={salary} onChange={salaryChange}
              onFocus={salaryFocus} onBlur={salaryBlurs} />
            元
          </section>
          {salaryFlag && <span>请填写人均薪酬成本</span>}
        </section>
        <section className='modle-bot'>
          <b className='sure' onClick={canSure}>确认</b>
          <b className='cancel' onClick={closeModel}>取消</b>
        </section>
      </section>
    </DModal >
  );
};

export default observer(DataModel);
